module.exports = __webpack_public_path__ + "static/media/90BirthdayGif.76b9a890.gif";